<cue-datetimepicker
  [timeOnly]="true"
  [incompleteDateValidation]="true"
  [autoCorrectParts]="false"
  [allowCaretMode]="true"
  [autoSwitchParts]="false"
  [format]="format()"
  [steps]="steps()"
  [enterKeyBehavior]="enterKeyBehavior()"
  (focus)="focus($event)"
  (blur)="blur()"
  (close)="blur()"
  placeholder=""
  [formControl]="_control"
  [clearButton]="showClear()"
  [popupSettings]="{
    appendTo: appendTo(),
    popupClass: popupClass(),
  }"
  [popupOrigin]="popupOrigin()"
  [min]="min()"
  [max]="max()"
  [messages]="{
    accept: translation.leftMenu.accept | transloco,
    cancel: translation.leftMenu.cancel | transloco,
    clear: translation.reservations.clear | transloco,
    open: translation.leftMenu.time | transloco,
    hour: translation.common.shortDurationUnits.hours | transloco,
    minute: translation.common.shortDurationUnits.minutes | transloco,
  }"
/>
